import CircularProgress from '@material-ui/core/CircularProgress';
import {useIntl} from 'react-intl';
import './HardwareTokenLoading.less';

interface HardwareTokenLoadingProps {
    messageKey?: string;
}

/**
 * Loading spinner component for hardware token signing flow.
 * Displays a centered spinner with an optional message.
 */
export function HardwareTokenLoading({
    messageKey = 'hardwareToken.connecting'
}: HardwareTokenLoadingProps): JSX.Element {
    const {formatMessage} = useIntl();

    return (
        <div
            className="hardware-token-loading"
            data-wdio="test-hardware-token-loading"
        >
            <CircularProgress
                className="hardware-token-loading-spinner"
                size={48}
                aria-hidden
            />
            <p className="hardware-token-loading-message">
                {formatMessage({id: messageKey, defaultMessage: ''})}
            </p>
        </div>
    );
}
